'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ScheduleWeekNavigatorDirective=function(_BaseControllerBacked){_inherits(ScheduleWeekNavigatorDirective,_BaseControllerBacked);function ScheduleWeekNavigatorDirective(){_classCallCheck(this,ScheduleWeekNavigatorDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ScheduleWeekNavigatorDirective,[{key:'templateUrl',get:function()
{return'/templates/directives/scheduleWeekNavigatorDirective/scheduleWeekNavigatorTemplate'}},{key:'objectBindings',get:function()
{return['scheduleBounds','selectedWeek','timezone']}},{key:'controller',get:function()
{return ScheduleWeekNavigatorController}}]);return ScheduleWeekNavigatorDirective}(BaseControllerBackedDirective);let


ScheduleWeekNavigatorController=function(){_createClass(ScheduleWeekNavigatorController,null,[{key:'$inject',get:function()
{return['$timeout','$state']}}]);
function ScheduleWeekNavigatorController($timeout,$state){_classCallCheck(this,ScheduleWeekNavigatorController);
this._$timeout=$timeout;
this._$state=$state;
}ScheduleWeekNavigatorController.prototype.

goToNow=function goToNow(){var _this2=this;
if(this.isAtNow()){
return;
}

this._$timeout(function(){
_this2._$state.go('fdc.features.personalSchedule',{interval:TimeInterval.fromPoint(new Date)});
});
};ScheduleWeekNavigatorController.prototype.

goToNextWeek=function goToNextWeek(){var _this3=this;
if(this.isAtScheduleEnd()){
return;
}

this._$timeout(function(){
_this3._goToInterval(_this3.selectedWeek.shift('weeks',1,_this3.timezone));
});
};ScheduleWeekNavigatorController.prototype.

goToPreviousWeek=function goToPreviousWeek(){var _this4=this;
if(this.isAtScheduleStart()){
return;
}

this._$timeout(function(){
_this4._goToInterval(_this4.selectedWeek.shift('weeks',-1,_this4.timezone));
});
};ScheduleWeekNavigatorController.prototype.

isAtScheduleStart=function isAtScheduleStart(){
return this.selectedWeek.contains(this.scheduleBounds.start);
};ScheduleWeekNavigatorController.prototype.

isAtNow=function isAtNow(){
return this.selectedWeek.contains(new Date);
};ScheduleWeekNavigatorController.prototype.

isAtScheduleEnd=function isAtScheduleEnd(){
return this.selectedWeek.contains(this.scheduleBounds.end);
};ScheduleWeekNavigatorController.prototype.

_goToInterval=function _goToInterval(interval){
this._$state.go('fdc.features.personalSchedule',{interval:interval});
};return ScheduleWeekNavigatorController}();


module.exports=ScheduleWeekNavigatorDirective;
//# sourceMappingURL=scheduleWeekNavigatorDirective.js.map
